import { render, staticRenderFns } from "./Deliveries.vue?vue&type=template&id=5c84535e&"
import script from "./Deliveries.vue?vue&type=script&lang=js&"
export * from "./Deliveries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports